import moment from 'moment'

import { useEffect } from 'hooks'

import { formatDateToBackend } from 'helpers/date'

import { useCustomRange } from '../Security/hooks'

const TODAY = formatDateToBackend(new Date()) as string

const calculateFromDate = (amount: number, unit: moment.unitOfTime.DurationConstructor): string => {
  return formatDateToBackend(moment().subtract(amount, unit)) as string
}

const usePreviousPeriodEffect = (previousPeriod: string | null, security: any): void => {
  const { setChartValue, inputValue } = useCustomRange()

  useEffect(() => {
    if (!previousPeriod || previousPeriod === 'range' || inputValue.from || inputValue.to) return

    const to = TODAY
    let from = ''

    switch (previousPeriod) {
      case 'week':
        from = calculateFromDate(1, 'week')
        break
      case 'month':
        from = calculateFromDate(1, 'month')
        break
      case 'six_months':
        from = calculateFromDate(6, 'month')
        break
      case 'year':
        from = calculateFromDate(1, 'year')
        break
      case 'max':
        from = formatDateToBackend(new Date(security?.history?.daily?.[0]?.date)) ?? ''
        break
    }

    setChartValue({ from, to })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previousPeriod, security, setChartValue])
}

export { usePreviousPeriodEffect }
